/* 🤖 this file was generated by svg-to-ts*/
export const iconChevronRight = {
  name: 'chevron_right',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.713 5.626l5.667 5.668a1 1 0 010 1.415l-5.667 5.67A1 1 0 119.3 16.962l4.96-4.961-4.96-4.962a1 1 0 011.414-1.414z"/></svg>`,
}
